import { Injectable } from "@angular/core";
import { ApplicationInsights} from '@microsoft/applicationinsights-web';
import { environment } from "../../../../environments/environment";

@Injectable({ 
    providedIn: 'root' 
})
export class MonitoringService {
    appInsights: ApplicationInsights;
    
    constructor() {
        this.appInsights = new ApplicationInsights({ config: {
            instrumentationKey: environment.appInsights.instrumentationKey,
          } });
        this.appInsights.loadAppInsights();
    }

    logPageView(name?: string, url?: string) {
        this.appInsights.trackPageView({ 
            name: name,
             uri: url
        });
    }

    logEvent(name: string, properties?: { [key: string]: any; }) {
        this.appInsights.trackEvent({ 
            name: name,
            properties: properties
        });
    }

    logMetric(name: string, average: number, sampleCount?: number, min?: number, max?: number, properties?: { [key: string]: any; }) {
        this.appInsights.trackMetric({ 
            name: name,
            average: average,
            sampleCount: sampleCount,
            min: min,
            max: max,
            properties: properties
        });
    }

    logException(exception: Error, severityLevel?: number, properties?: { [key: string]: any; }, measurements?: { [key: string]: number; }) {
        this.appInsights.trackException({ 
            exception: exception,
            severityLevel: severityLevel,
            properties: properties,
            measurements: measurements
        });
    }

    logTrace(message: string, severityLevel?: number, properties?: { [key: string]: any; }) {
        this.appInsights.trackTrace({ 
            message: message,
            severityLevel: severityLevel,
            properties: properties
        });
    }
}